import { transformRelationsToFlat } from "./flatten";
import type { DynamicStructure } from "../types";

/**
 * Resolve um path `a.b.c` contra a `DynamicStructure` (após flatten de
 * relations). Retorna `undefined` se qualquer elo for ausente ou não-objeto.
 */
export function resolvePath(
  structure: DynamicStructure,
  path: string,
): unknown {
  const flatStructure = transformRelationsToFlat(structure);
  const keys = path.split(".");
  let value: any = flatStructure;
  for (const key of keys) {
    if (value == null || typeof value !== "object") return undefined;
    value = value[key];
  }
  return value;
}
